// ---------------------------------------------------------------------------
// Liturgia do dia: o aparelho liga (ou desliga) o aviso diário das 6h. Quem
// envia é o banco; aqui só falamos com push_liturgia_situacao / push_liturgia,
// presos ao endpoint desta assinatura. Nada é criado no banco.
// ---------------------------------------------------------------------------

import { supabase } from './supabase';
import { suportaAvisos } from './avisos';

export interface SituacaoLiturgia {
  /** Este aparelho tem assinatura de push? */
  assinado: boolean;
  /** A assinatura de avisos está ativa? */
  ativa: boolean;
  /** O aviso do Evangelho está ligado? */
  liturgia: boolean;
}

const VAZIO: SituacaoLiturgia = { assinado: false, ativa: false, liturgia: false };

async function endpointAtual(): Promise<string | null> {
  if (!suportaAvisos()) return null;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return sub?.endpoint ?? null;
  } catch {
    return null;
  }
}

export async function situacaoLiturgia(): Promise<SituacaoLiturgia> {
  const endpoint = await endpointAtual();
  if (!endpoint) return VAZIO;
  try {
    const { data, error } = await supabase.rpc('push_liturgia_situacao', {
      p_endpoint: endpoint,
    });
    if (error) return VAZIO;
    const d = (Array.isArray(data) ? data[0] : data) as Record<string, unknown> | null;
    return {
      assinado: d?.assinado === true,
      ativa: d?.ativa === true,
      liturgia: d?.liturgia === true,
    };
  } catch {
    return VAZIO;
  }
}

// Liga/desliga o Evangelho todo dia. Devolve o novo estado.
export async function definirLiturgia(ligado: boolean): Promise<boolean> {
  const endpoint = await endpointAtual();
  if (!endpoint) throw new Error('Ative os avisos neste celular primeiro.');
  const { data, error } = await supabase.rpc('push_liturgia', {
    p_endpoint: endpoint,
    p_ligado: ligado,
  });
  if (error) throw error;
  const d = (Array.isArray(data) ? data[0] : data) as { liturgia?: boolean } | null;
  return d?.liturgia === true;
}